// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import { Typography } from "@material-ui/core";
import { useLocMessage } from "../../../store/localization/hooks";
import { EpicLink } from "../EpicLink";

export interface IErrorCodeProps {
  errorCode: string;
}

export function ErrorCode({ errorCode }: IErrorCodeProps): JSX.Element {
  const link = `https://launcherhelp.epicgames.com/customer/portal/articles/search?q=${errorCode}`;
  const errorCodeMessage = useLocMessage("error.errorCode", "Error Code:");

  return (
    <Typography variant="caption">
      {errorCodeMessage}{" "}
      <EpicLink color="primary" href={link} target="_blank">
        {errorCode}
      </EpicLink>
    </Typography>
  );
}
